import { useWorkspacesPage } from './WorkspacesPageContext';
import { WorkspacesPageControls } from './WorkspacesPageControls';
import { WorkspacesPageGrid } from './WorkspacesPageGrid';
import { WorkspacesPageHeader } from './WorkspacesPageHeader';
import { WorkspacesPageModals } from './WorkspacesPageModals';
import { WorkspacesPageTable } from './WorkspacesPageTable';

export const WorkspacesPageBody = () => {
  const { viewMode } = useWorkspacesPage();
  return (
    <div className="h-full w-full flex flex-col items-center">
      <WorkspacesPageHeader />
      <WorkspacesPageControls />
      <div className="w-ds-page flex-auto overflow-y-hidden pb-4">
        {viewMode === 'table' ? (
          <WorkspacesPageTable />
        ) : (
          <WorkspacesPageGrid />
        )}
      </div>
      <WorkspacesPageModals />
    </div>
  );
};
